import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";

import OneProject from "./OneProject";

export default function ProjectsBanner(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllProjects(),
    ]);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <div
        className="MainBodySection bg-background"
        style={{
          paddingTop: "50px",
          paddingBottom: "50px"
        }}
      >
        <div className="container">

        
          <div className="row">

            <div className="col-md-12">
              <h6
                className="main-section-title"
              >
                Projects
                <span
                  style={{
                    display: "block",
                    borderBottom: "3px solid var(--secondaryColor)",
                    width: "50px",
                    marginTop: "10px"
                  }}
                >

                </span>
              </h6>
            </div>

            {
              (appContext.allProjects && appContext.allProjects.length > 0)
                ? appContext.allProjects.map((item, i) => (
                    <div key={i} className="col-md-6">
                      <OneProject data={item} />
                    </div>
                  ))
                : (
                  <div className="col-md-12 mb-1 mt-1">
                    <h6>No data was found</h6>
                  </div>
                )
            }

          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
